import React, { Fragment } from 'react';
import { FormatDate } from '../../../renderField/hookForms';
import { RenderCurrency, RenderDollar, RenderKilogramo } from '../../../renderField/renderReadField';

/**
 * Componente para mostrar la tabla de bonificaciones de fletes
 * @param {Object} props - Props del componente
 * @param {Array} props.recepciones - Array de recepciones
 * @param {boolean} props.reportMode - Modo de reporte
 * @returns {JSX.Element}
 */
const TablaBonifFletes = (props) => {
    const { recepciones, reportMode = false } = props;

    const emptyColSpan = reportMode ? 10 : 8;

    return (
        <Fragment>
            <table>
                <thead>
                    <tr>
                        <th>RECEPCIÓN</th>
                        {reportMode && <th>LIQUIDACIÓN</th>}
                        <th>FECHA</th>
                        {reportMode && <th>FINCA</th>}
                        <th className='th--right'>KG SECOS</th>
                        <th className='th--right'>PESO NETO</th>
                        <th className='th--right'>KG MÍNIMOS</th>
                        <th className='th--right'>BONO POR KG</th>
                        <th className='th--right th--no-wrap'>BONIFICACIÓN $</th>
                        <th className='th--right th--no-wrap'>BONIFICACIÓN Q</th>
                    </tr>
                </thead>
                <tbody>
                    {/* mostrar una fila vacía */}
                    {recepciones.length === 0 &&
                        <tr>
                            <td colSpan={emptyColSpan} className='text-center'>No hay datos para mostrar</td>
                        </tr>
                    }
                    {recepciones.map((item, index) => {
                        let colorClassName = 'text-danger font-weight-bold';
                        if (item.bonificacion > 0) {
                            colorClassName = 'text-success font-weight-bold ';
                        }

                        return (
                            <tr key={index}>
                                <td>{item.id_recepcion}</td>
                                {reportMode &&
                                    <td label="Liquidación">
                                        {item.orden_compra_id}
                                    </td>
                                }
                                <td>{FormatDate(item.fecha)}</td>
                                {reportMode &&
                                    <td
                                        label="Finca"
                                        className='td--name'>
                                        {item.nombre}
                                    </td>
                                }
                                <td
                                    label="Kg Secos"
                                    className='td--right td--no-wrap'>
                                    <RenderKilogramo value={item.kilos_secos} />
                                </td>
                                <td
                                    label="Peso Neto"
                                    className={`td--right td--no-wrap ${colorClassName}`}>
                                    <RenderKilogramo value={item.peso_neto} />
                                </td>
                                <td
                                    label="Kg mínimos"
                                    className='td--right td--no-wrap'>
                                    <RenderKilogramo value={item.bonif_fletes_min_kg} />
                                </td>
                                <td
                                    label="Bono por Kg"
                                    className='td--right td--no-wrap'>
                                    <RenderDollar value={item.bonif_fletes_bono_por_kg} decimalScale={4} />
                                </td>
                                <td
                                    label="Bonificación $"
                                    className='td--right td--no-wrap'>
                                    <RenderDollar value={item.bonificacion} decimalScale={4} />
                                </td>
                                <td
                                    label="Bonificación Q"
                                    className='td--right td--no-wrap'>
                                    <RenderCurrency value={item.bonificacion_quetzales} decimalScale={4} />
                                </td>
                            </tr>
                        )
                    }
                    )}
                </tbody>
            </table>
        </Fragment>
    )
};

export default TablaBonifFletes;
